import { IRouteViewModel, Params, RouteNode } from '@aurelia/router-lite';
import { lifecycleHooks } from '@aurelia/runtime-html';
import { inject } from 'aurelia';
import { TokenService } from '../../services/token-service';
import { AuthenticationHandler } from '../extensions';

@lifecycleHooks()
@inject(TokenService, AuthenticationHandler)
export class AuthorizeHook {
    public constructor(
        private tokenService: TokenService,
        private authHandler: AuthenticationHandler
    ) {}

    public async canLoad(_viewmodel: IRouteViewModel, _params: Params, next: RouteNode) {
        const requiresAuth = next.data?.auth;
        const isLoggedIn = this.tokenService.isTokenValid();

        if (requiresAuth && !isLoggedIn) {
            void this.authHandler.redirectToSSO({});
            return false;
        }

        return true;
    }
}
